import {
  CriteriaChoice,
  CriteriaSet,
} from '../../../shared/criteria/domain/criteria';
import { Option } from '../../../shared/options/domain/option';
import { MAX_SCORE } from '../../scores/domain/score';

type PromptObject = {
  name: string;
  message: string;
  choices: CriteriaChoice[];
};

export type ComputedResult = {
  option: Option<string>;
  percentage: number;
};

export default class PromptRunner {
  private readonly criteriaSet: CriteriaSet<string>;
  private readonly options: Option<string>[];
  constructor(criteriaSet: CriteriaSet<string>, options: Option<string>[]) {
    this.criteriaSet = criteriaSet;
    this.options = options;
  }

  mapQuestions(): PromptObject[] {
    const questions: PromptObject[] = [];
    for (const [key, criteria] of Object.entries(this.criteriaSet)) {
      questions.push({
        name: key,
        message: criteria.prompt ?? criteria.name,
        choices: criteria.choices,
      } as PromptObject);
    }
    return questions;
  }

  computeResults(responses: Record<string, number>): ComputedResult[] {
    const r = this.options.map(option => {
      let score = 0;

      for (const [criteriaKey, criteria] of Object.entries(this.criteriaSet)) {
        const optionCriteriaScore =
          option.criteriaScores[criteriaKey].score.value;
        score +=
          (1 -
            Math.abs(optionCriteriaScore - responses[criteriaKey]) /
              MAX_SCORE) *
          (criteria.weight ?? 1);
      }

      return {
        option,
        percentage: (score / Object.keys(this.criteriaSet).length) * 100,
      };
    });
    r.sort((a, b) => b.percentage - a.percentage);
    return r.slice(0, 5);
  }
}
